<template>
  <v-snackbar v-model="snackbar" :color="snackbarData.color" auto-height bottom :timeout="5000">
    {{ snackbarData.text }}
    <v-btn class="mr-5 ml-0" flat @click="hideSnackbar()">
      סגירה
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  data: () => ({

  }),

  computed: {
    snackbar: {
      get()  {
        return this.$store.getters['snackbar'];
      },
      set(val) {
        return this.$store.commit('SET_SNACKBAR', val);
      }
    },
    snackbarData() {
      return this.$store.getters['snackbarData'];
    }
  },

  methods: {
    hideSnackbar() {
      this.$store.dispatch('HIDE_SNACKBAR');
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Snackbar.vue